<template>
  <div class="input-group">
    <input-comp label="Código" v-model="codigo" @change="updateData"/>
  </div>
</template>

<script>
  import InputComp from "../../../Componentes_Globales/Input/inputComp";
  import {mapActions} from "vuex";

  export default {
    name: "Codigo",
    components: {InputComp},
    methods: {
      ...mapActions({
        getData: "sugeridoCompra/getProductosSugerido"
      }),
      updateData() {
        this.getData()
        this.$store.dispatch("sugeridoCompra/resetPages")
      }
    },
    computed: {
      codigo: {
        get() {
          return this.$store.state.sugeridoCompra.filtros.codigo
        },
        set(value) {
          this.$store.commit("sugeridoCompra/SET_FILTRO", {key: "codigo", data: value})
        }
      }
    }
  }
</script>

<style scoped>

</style>
